export const arrayCompare = (a: any, b: any): boolean => {
  if (a.length !== b.length) return false;
  const uniqueValues = Array.from(new Set([...a, ...b]));
  for (let i = 0; i < uniqueValues.length; i += 1) {
    const v = uniqueValues[i];
    const aCount = a.filter((e: any) => e === v).length;
    const bCount = b.filter((e: any) => e === v).length;
    if (aCount !== bCount) return false;
  }
  return true;
};

export const arrayCompareOrder = (a: any, b: any) => a.length === b.length && a.every((v: any, i: any) => v === b[i]);
